module.exports = __webpack_public_path__ + "static/media/8H.f6325833.svg";